import React from 'react'
import ReactWordcloud from 'react-wordcloud'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'
import * as Styled from './WordCloud.styled'

interface WordCount {
  word: string
  totalCount: number
}

interface WordCloudProps {
  data?: WordCount[]
}

const WordCloud: React.FC<WordCloudProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Styled.WordCloudContainer>
        <div className="no-data">
          <h3>Kelime bulutu verisi bulunamadı</h3>
        </div>
      </Styled.WordCloudContainer>
    )
  }

  const words = data.map((item: WordCount) => ({
    text: item.word,
    value: item.totalCount,
  }))

  return (
    <Styled.WordCloudContainer>
      <div className="word-cloud-content">
        <ReactWordcloud
          options={{
            colors: [
              '#1f77b4',
              '#ff7f0e',
              '#2ca02c',
              '#d62728',
              '#9467bd',
              '#8c564b',
              '#e377c2',
              '#7f7f7f',
              '#bcbd22',
              '#17becf',
            ],
            enableTooltip: true,
            deterministic: false,
            fontFamily: 'impact',
            fontSizes: [20, 80],
            fontStyle: 'normal',
            fontWeight: 'normal',
            padding: 2,
            rotations: 2,
            rotationAngles: [0, 0],
            scale: 'sqrt',
            spiral: 'archimedean',
            transitionDuration: 1000,
          }}
          size={[800, 500]}
          words={words}
        />
      </div>
    </Styled.WordCloudContainer>
  )
}

export default WordCloud 